
import React, { useState, useEffect, useRef } from "react";
import { Link, useParams } from "react-router-dom";
import { Icon } from "@iconify/react/dist/iconify.js";
import { api } from "../../helper/api.interceptor";
import AddUserModal from "../AddUserModal";
import Swal from "sweetalert2";

const SalesExecutive = () => {
    const [farmers, setFarmers] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [searchQuery, setSearchQuery] = useState("");
    const [filterStatus, setFilterStatus] = useState("All");
    const changeRef = useRef(Math.random());
    const [showAddModal, setShowAddModal] = useState(false);
    const { id } = useParams();

    const fetchFarmerFarmDataInit = async () => {
        try {
            const data = await api.getAllSalesExecutives();
            console.log(data);

            const sortedData = (data || []).sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
            setFarmers(sortedData);
        } catch (error) {
            console.error("Error fetching customers:", error);
        }

    };

    useEffect(() => {
        fetchFarmerFarmDataInit();
    }, []);

    const filteredFarmers = farmers.filter((farm) => {
        const query = searchQuery.trim().toLowerCase();
        const statusMatch = filterStatus === "All" || (farm?.documents?.status || "") === filterStatus;
        return statusMatch && (farm?.username || "").toLowerCase().includes(query);
    });

    const totalPages = Math.ceil(filteredFarmers.length / itemsPerPage);
    const indexOfFirstFarm = (currentPage - 1) * itemsPerPage;
    const indexOfLastFarm = currentPage * itemsPerPage;
    const currentFarmers = filteredFarmers.slice(indexOfFirstFarm, indexOfLastFarm);
    const indexOfFirstItem = indexOfLastFarm - itemsPerPage;

    useEffect(() => {
        if (currentPage > totalPages) {
            setCurrentPage(1);
        }
    }, [filteredFarmers, currentPage, totalPages]);

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
        setCurrentPage(1);
    };

    const handleItemsPerPageChange = (event) => {
        setItemsPerPage(Number(event.target.value));
        setCurrentPage(1);
    };

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };
    const handleRemoveRole = async (phone_number) => {
        const result = await Swal.fire({
            title: "Are you sure?",
            text: "This will remove the Sales Executive role from this user.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, remove role!",
            cancelButtonText: "Cancel",
        });

        if (result.isConfirmed) {
            try {
                const payload = {
                    phone_number,
                    role: "Sales Executive",
                };
                console.log(
                    "payload" + payload
                );


                const res = await api.removeUserRole(payload);

                if (res && res.status_code === 200) {
                    Swal.fire("Removed!", "Role removed successfully.", "success");
                    fetchFarmerFarmDataInit(); // refresh table
                } else {
                    Swal.fire("Error!", res.message || "Failed to remove role.", "error");
                }
            } catch (error) {
                Swal.fire("Error!", error.message, "error");
            }
        }
    };

    return (
        <div>
            <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-24">
                <h6 className="fw-semibold mb-0"> <Icon icon="mdi:account-tie" className="menu-icon" style={{ width: "30px", height: "30px" }} /> | Sales Executive</h6>
                <ul className="d-flex align-items-center gap-2">
                    <li className="fw-medium">
                        <Link to="/" className="d-flex align-items-center gap-1 hover-text-primary">
                            <Icon icon="solar:home-smile-angle-outline" className="icon text-lg" />
                            Role Management
                        </Link>
                    </li>
                    <li> - </li>
                    <li className="fw-medium">Sales Executive</li>
                </ul>
            </div>

            <div className="card">
                <div className="card-header d-flex flex-wrap align-items-center justify-content-between gap-3">
                    <div className="d-flex align-items-center gap-2">
                        <span>Show</span>
                        <select className="form-select form-select-sm w-auto" value={itemsPerPage} onChange={handleItemsPerPageChange}>
                            <option value="5">5</option>
                            <option value="10">10</option>
                            <option value="15">15</option>
                            <option value="20">20</option>
                            <option value={filteredFarmers.length}>All</option>
                        </select>
                    </div>

                    <div className="d-flex align-items-center gap-3">
                        <div className="icon-field">
                            <input type="text" className="form-control form-control-sm w-auto" placeholder="Search by Name" onChange={handleSearchChange} />
                            <span className="icon">
                                <Icon icon="ion:search-outline" />
                            </span>
                        </div>
                        <button
                            onClick={() => setShowAddModal(true)}
                            className="btn btn-warning rounded-pill fw-medium d-flex align-items-center gap-2"
                        >
                            <Icon icon="mdi:plus" className="fs-5" />
                            Add New Sales Executive
                        </button>
                    </div>


                </div>

                <div className="card-body" style={{ overflowX: "auto" }}>
                    <table className="table bordered-table mb-0">
                        <thead>
                            <tr>
                                <th>S.L</th>
                                <th>Sales Executive Name</th>
                                <th>Email</th>
                                <th>Phone Number</th>
                                {/* <th>state</th>
                                <th>District</th>
                                <th>city</th>
                                <th>street</th> */}
                                <th>warehouse name</th>
                                <th>pincode</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentFarmers.length === 0 ? (
                                <tr>
                                    <td colSpan="8" className="text-center">No Sales Executive found.</td>
                                </tr>
                            ) : (
                                currentFarmers.map((farmer, index) => (
                                    <tr key={farmer._id}>
                                        <td>{indexOfFirstItem + index + 1}</td>
                                        <td>{farmer?.username || "No Name Available"}</td>
                                        <td>{farmer?.emailid || "No Email Available"}</td>
                                        <td>{farmer?.phone_number || "No Email Available"}</td>
                                        {/* <td>{farmer?.address.state || "No Phone Provided"}</td>
                                        <td>{farmer?.address.district}</td>
                                        <td>{farmer?.address.city || "Not Available"}</td>
                                        <td>{farmer?.address.street || "Pending"}</td> */}
                                        <td>{farmer?.warehouse_name || "Pending"}</td>
                                        <td>{farmer?.address.pincode || "Pending"}</td>
                                        <td>
                                            <Link
                                                to={`/Sales_Executive_details/${encodeURIComponent(farmer?.phone_number)}`}
                                                className="w-32-px h-32-px me-8 bg-primary-light text-primary-600 rounded-circle d-inline-flex align-items-center justify-content-center"
                                            >
                                                <Icon icon="iconamoon:eye-light" />
                                            </Link>
                                            <Link
                                                onClick={() => handleRemoveRole(farmer.phone_number)}
                                                className="w-32-px h-32-px me-8 bg-danger-focus text-danger-main rounded-circle d-inline-flex align-items-center justify-content-center"
                                            >
                                                <Icon icon="mingcute:delete-2-line" />
                                            </Link>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>

                    <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mt-24">
                        <span>Showing {indexOfFirstFarm + 1} to {Math.min(indexOfLastFarm, filteredFarmers.length)} of {filteredFarmers.length} entries</span>
                        <nav>
                            <ul className="pagination">
                                {Array.from({ length: totalPages }, (_, index) => (
                                    <li key={index} className={`page-item ${currentPage === index + 1 ? "active" : ""}`}>
                                        <button className="page-link" onClick={() => handlePageChange(index + 1)}>{index + 1}</button>
                                    </li>
                                ))}
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>
            {/* Add Sales Executive Modal */}
            {showAddModal && (
                <AddUserModal
                    show={showAddModal}
                    onClose={() => setShowAddModal(false)}
                    onUserAdded={fetchFarmerFarmDataInit} // refresh table after adding
                />
            )}
        </div>
    );
};


export default SalesExecutive;
